<template>
  <div class="content">
    <header>
      <h1>医 院 后 勤 价 值 评 价</h1>
    </header>
    <el-card class="card">
      <el-form ref="form" inline="true" :model="form" :rules="rules" label-width="80px">
        <div class="card-box">
          <div class="card-input">
            <div>
              <span class="label">评价内容:</span>
              <el-select
                v-model="selectValue"
                @change="change"
                style="width: 360px; max-height: 70px;"
                multiple="true"
                width="400px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input" v-for="(item, index) in input" :key="index">
              <!-- <span class="label">{{item.label}}:</span> -->
              <el-form-item :label="item.label" prop="0">
                <el-input
                  type="number"
                  :label="item"
                  v-model="form[index]"
                  style="width: 200px;"
                  placeholder="请输入金额"
                >
                </el-input>
                <el-switch
                  style="margin-left: 10px;"
                  v-model="switchList[index]"
                  active-text="加"
                  inactive-text="减"
                >
                </el-switch>
              </el-form-item>
            </div>
          </div>
          <div class="card-button">
            <div class="card-button-round1">
              <button class="card-button-round2" @click.prevent="calculate(form)">
                计算
              </button>
            </div>
          </div>
          <div class="card-result">
            <div class="card-result-content">
              <div class="result">
                评价总值:<span class="money"> {{ total }} </span> 元
              </div>

              <div style="margin-top: 60px;">
                价值累加:<span class="money"> {{ add }} </span> 元
              </div>
              <div style="margin-top: 30px;">
                价值累减:<span class="money"> {{ loase }} </span> 元
              </div>
            </div>
            <div
              style="
                width: 250px;
                font-size: 16px;
                color: #999;
                margin: auto;
                padding: 20px 20px;
                border-top: 1px solid #999;
                margin-top: 20px;
              "
            >
              提示：本次价值评价仅供参考！
            </div>
          </div>
        </div>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: '?',
      add: '?',
      loase: '?',
      form: {
        0: '',
        1: '',
        2: '',
        3: '',
        4: '',
        5: '',
      },
      switchList: {
        0: true,
        1: true,
        2: true,
        3: true,
        4: true,
        5: true,
      },
      options: [
        {
          value: '环境管理',
          label: '环境管理',
        },
        {
          value: '中央运送',
          label: '中央运送',
        },
        {
          value: '工程管理',
          label: '工程管理',
        },
        {
          value: '餐饮服务',
          label: '餐饮服务',
        },
        {
          value: '导医服务',
          label: '导医服务',
        },
      ],
      input: [],
      selectValue: ['环境管理', '中央运送', '工程管理', '餐饮服务'],
      rules: {
        0: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          {
            pattern: this.$validation.number,
            message: '请输入可以带有两位小数的正数',
            trigger: 'change',
          },
        ],
      },
      result: '',
    };
  },
  created() {
    let arr = [];
    for (var i = 0; i < this.selectValue.length; i++) {
      arr[i] = {};
      arr[i].label = this.selectValue[i];
      arr[i].value = '';
      this.form[i] = '';
    }
    this.input = arr;
  },
  methods: {
    calculate(form) {
      let total = 0;
      let add = 0;
      let loase = 0;
      let reg = this.$validation.number;
      for (var i = 0; i < this.input.length; i++) {
        if (this.form[i] == '') {
          this.$message({
            message: `${this.input[i].label}不能为空哟`,
            type: 'warning',
          });
          return;
        }
        if (!reg.test(this.form[i])) {
          this.$message({
            message: `${this.input[i].label}请输入可以带有两位小数的数字`,
            type: 'warning',
          });
          return;
        }
        if (this.switchList[i]) {
          total += Number(this.form[i]);
          add += Number(this.form[i]);
        } else {
          total -= Number(this.form[i]);
          loase += Number(this.form[i]);
        }
      }
      this.total = total;
      this.add = add;
      this.loase = loase;
    },
    change(val) {
      let arr = [];
      for (var i = 0; i < val.length; i++) {
        arr[i] = {};
        arr[i].label = val[i];
        arr[i].value = '';
        this.form[i] = '';
      }
      this.input = arr;
      this.total = '?';
      this.loase = '?';
      this.add = '?';
    },
  },
};
</script>
<style scoped>
.card-result-content {
  margin: auto;
  /* width: 200px; */
  margin-left: 40px;
  text-align: center;
}
.card-button-round1 {
  position: absolute;
  width: 100px;
  height: 100px;
  border: 1px solid rgba(64, 158, 255, 0.5);
  left: -50px;
  top: 50%;
  margin-top: -50px;
  border-radius: 50%;
  line-height: 100px;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.7);
}
.card-button-round2 {
  margin: auto;
  margin-top: 10px;
  animation: myfirst 2s;
  animation-iteration-count: infinite;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #fff;
  box-shadow: 1px 1px 20px #f00;
  border: 1px solid rgba(64, 158, 255, 0.5);
  background-color: rgba(64, 158, 255, 1);
  border-radius: 50%;
}
.card-button-round2:hover {
  cursor: pointer;
}
@keyframes myfirst {
  0% {
    box-shadow: 1px 1px 3px #000;
    width: 75px;
    height: 75px;
    line-height: 75px;
  }
  10% {
    box-shadow: 1px -1px 3px #000;
    width: 70px;
    height: 70px;
    line-height: 70px;
  }
  20% {
    box-shadow: -1px -1px 3px #000;
    width: 75px;
    height: 75px;
    line-height: 75px;
  }
  30% {
    box-shadow: -1px 1px 3px #000;
    width: 80px;
    height: 80px;
    line-height: 80px;
  }

  40% {
    box-shadow: 1px 1px 8px #000;
  }
  50% {
    box-shadow: 1px 1px 10px #000;
  }
  60% {
    box-shadow: 1px 1px 12px #000;
  }
  70% {
    box-shadow: 1px 1px 14px #000;
  }
  80% {
    box-shadow: 1px 1px 16px #000;
  }
  90% {
    box-shadow: 1px 1px 18px #000;
  }
  100% {
    box-shadow: 1px 1px 20px #000;
  }
}
.content {
  margin: 0;
  margin-top: -25px;
  padding: 0;
  width: 100%;
  height: 100%;
  background-image: url('./hospital.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  /* text-align: center; */
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    '微软雅黑', Arial, sans-serif;
}
header {
  /* float: left; */
  margin-top: 50px;
  width: 400px;
  padding: 1px 5px;
  text-align: center;
  background-color: rgba(64, 158, 255, 0.5);
}
.card {
  margin: 50px auto;
  padding: 10px;
  min-width: 900px;
  width: 80%;
  min-height: 300px;
  background-color: rgba(255, 255, 255, 0.7);
}
.card-box {
  display: flex;
  justify-content: space-between;
}
.input {
  margin-top: 10px;
  text-align: left;
}
.label {
  display: inline-block;
  width: 80px;
  text-align: right;
}
.card-input {
  width: 50%;
  flex-shrink: 0;
  flex-grow: 0;
  min-height: 270px;
}
.card-button {
  position: relative;
  border-left: 1px solid rgba(64, 158, 255, 0.5);
  width: 0px;
  /* min-height: 300px; */
  border-radius: 50%;
  height: inherit;
}
.card-result {
  text-align: center;
  padding: 0 20px;
  width: 45%;
  font-size: 20px;
  font-weight: bold;
}
.money {
  color: #f00;
}
</style>
